export type SignupStep = "payment" | "account" | "onboarding";

const STEPS: { key: SignupStep; label: string }[] = [
  { key: "payment", label: "Payment" },
  { key: "account", label: "Account" },
  { key: "onboarding", label: "Onboarding" },
];

interface Props {
  currentStep: SignupStep;
}

export function SignupStepper({ currentStep }: Props) {
  const currentIndex = STEPS.findIndex((s) => s.key === currentStep);

  return (
    <div className="sp-stepper" aria-label="Signup progress">
      {STEPS.map((step, idx) => {
        const isCurrent = idx === currentIndex;
        const isComplete = idx < currentIndex;
        const classes = ["sp-step", isCurrent && "is-current", isComplete && "is-complete"]
          .filter(Boolean)
          .join(" ");
        return (
          <div key={step.key} className={classes}>
            <span className="sp-step-label">
              {isCurrent && <span className="sp-eyebrow-dot" aria-hidden="true" />}
              {step.label}
            </span>
            <span className="sp-step-bar" aria-hidden="true" />
          </div>
        );
      })}
    </div>
  );
}
